import { forwardRef, type InputHTMLAttributes } from "react";
import styles from "./toggle.module.scss";

export interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ label, checked, disabled, className, onChange, ...props }, ref) => {
    const wrapperCls = [
      styles.wrapper,
      disabled ? styles.disabled : "",
      className ?? "",
    ].filter(Boolean).join(" ");

    return (
      <label className={wrapperCls}>
        <input
          ref={ref}
          type="checkbox"
          className={styles.hiddenInput}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          {...props}
        />
        <span className={`${styles.track} ${checked ? styles.trackChecked : ""}`}>
          <span className={`${styles.thumb} ${checked ? styles.thumbChecked : ""}`} />
        </span>
        {label && <span className={styles.label}>{label}</span>}
      </label>
    );
  },
);

Toggle.displayName = "Toggle";
